(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4691],{

/***/ 84691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DisfruteAbadiaRetuerta": function() { return /* binding */ DisfruteAbadiaRetuerta; },
  "DisfruteDelWellness": function() { return /* binding */ DisfruteDelWellness; },
  "ExperienciasUnicas": function() { return /* binding */ ExperienciasUnicas; },
  "GastronomiaDeAbadia": function() { return /* binding */ GastronomiaDeAbadia; },
  "RegaleUnaExperiencia": function() { return /* binding */ RegaleUnaExperiencia; },
  "UnHotelAMedida": function() { return /* binding */ UnHotelAMedida; },
  "default": function() { return /* binding */ ab_cards_src; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ../packages/ab-text/src/index.tsx
var ab_text_src = __webpack_require__(145);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../packages/ab-card-services/src/services-card.scss
var services_card = __webpack_require__(55723);
;// CONCATENATED MODULE: ../packages/ab-card-services/src/index.tsx




var ServicesCard = function(param) {
    var src = param.src, srcSet = param.srcSet, label = param.label, href = param.href, two = param.two, link = param.link;
    ;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        className: "services-card",
        href: href || (link === null || link === void 0 ? void 0 : link.url),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "image",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: src || "/images/404.png",
                    layout: "fill",
                    alt: "label"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                element: "span",
                className: "tile",
                children: label
            })
        ]
    });
};
/* harmony default export */ var src = (ServicesCard);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../packages/ab-card-cross-selling/src/cross-selling-card.scss
var cross_selling_card = __webpack_require__(88389);
;// CONCATENATED MODULE: ../packages/ab-card-cross-selling/src/index.tsx





var CrossSellingCard = function(param) {
    var src = param.src, srcSet = param.srcSet, label = param.label, title = param.title, href = param.href, link = param.link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href || (link === null || link === void 0 ? void 0 : link.url),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            className: "cross-selling-card",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "image",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: src || "/images/404.png",
                        layout: "fill",
                        alt: label
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                    element: "span",
                    className: "titles",
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                    element: "span",
                    className: "title",
                    children: label
                })
            ]
        })
    });
};
/* harmony default export */ var ab_card_cross_selling_src = (CrossSellingCard);

// EXTERNAL MODULE: ../packages/ab-link/src/index.tsx
var ab_link_src = __webpack_require__(276);
// EXTERNAL MODULE: ../packages/ab-paragraph-text/src/index.tsx
var ab_paragraph_text_src = __webpack_require__(2569);
// EXTERNAL MODULE: ../packages/ab-functions/src/index.tsx + 9 modules
var ab_functions_src = __webpack_require__(5134);
// EXTERNAL MODULE: ../packages/ab-cards/src/ab-cards.scss
var ab_cards = __webpack_require__(34331);
;// CONCATENATED MODULE: ../packages/ab-cards/src/index.tsx










var Cards = function(param) {
    var title = param.title, text = param.text, _cards = param.cards, cards = _cards === void 0 ? [] : _cards, _className = param.className, className = _className === void 0 ? "" : _className, _classname = param.classname, classname = _classname === void 0 ? "" : _classname, link = param.link, animated = param.animated, linkBefore = param.linkBefore, linkbefore = param.linkbefore, textStyle = param.textStyle, i18n = param.i18n;
    var getLabel = function(itm) {
        if (i18n.language == "en") {
            return itm.labelEn || itm.label;
        }
        if (i18n.language == "de") {
            return itm.labelDe || itm.label;
        }
        return itm.label;
    };
    var getTitle = function(itm) {
        if (i18n.language == "ens") {
            return itm.titleEn || itm.title;
        }
        if (i18n.language == "de") {
            return itm.titleDe || itm.title;
        }
        return itm.title;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ab-cards ".concat(className || "", " ").concat(classname || ""),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "title",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_text_src/* default */.Z, {
                        element: "h2",
                        animated: animated,
                        style: textStyle,
                        children: title
                    }),
                    text ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_paragraph_text_src/* default */.Z, {
                        text: [
                            text
                        ],
                        singleColumn: true
                    }) : null
                ]
            }),
            link && (linkBefore || linkbefore) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_link_src/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                prefetch: false
            }, link), {
                className: "before"
            })) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: cards.map(function(itm, index) {
                    var ref, ref1, ref2, ref3, ref4;
                    return itm.title && itm.label ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_card_cross_selling_src, {
                        src: itm.src || itm.image.mediaItemUrl,
                        srcSet: (itm === null || itm === void 0 ? void 0 : itm.srcSet) || ((ref = itm.imagemobile) === null || ref === void 0 ? void 0 : ref.mediaItemUrl),
                        label: getLabel(itm),
                        title: getTitle(itm),
                        href: (0,ab_functions_src/* getTranslation */.i0)({
                            link: itm.page
                        }, "uri", {
                            code: i18n === null || i18n === void 0 ? void 0 : (ref1 = i18n.language) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase()
                        }) || itm.href,
                        link: itm.link
                    }, "cross-card-".concat(index)) : /*#__PURE__*/ (0,jsx_runtime.jsx)(src, {
                        src: itm.src || ((ref2 = itm.image) === null || ref2 === void 0 ? void 0 : ref2.mediaItemUrl),
                        srcSet: (itm === null || itm === void 0 ? void 0 : itm.srcSet) || ((ref3 = itm.imagemobile) === null || ref3 === void 0 ? void 0 : ref3.mediaItemUrl),
                        label: getLabel(itm),
                        href: (0,ab_functions_src/* getTranslation */.i0)({
                            link: itm.page
                        }, "uri", {
                            code: i18n === null || i18n === void 0 ? void 0 : (ref4 = i18n.language) === null || ref4 === void 0 ? void 0 : ref4.toUpperCase()
                        }) || itm.href,
                        link: itm.link
                    }, "service-card-".concat(index));
                })
            }),
            link && !linkBefore && !linkbefore ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ab_link_src/* default */.Z, {
                prefetch: false,
                text: link.text || link.title,
                href: link.href || link.url,
                target: link.target
            }) : null
        ]
    });
};
var DisfruteAbadiaRetuerta = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards, {
        title: "Disfrute de Abad\xeda Retuerta",
        cards: [
            {
                src: "/images/descubra-nuestro-hotel-desk-x2.jpg",
                srcSet: "/images/descubra-nuestro-hotel-mobile-x2.jpg",
                label: "Descubra nuestro hotel",
                href: "/hotel-spa-valladolid-ribera-del-duero"
            },
            {
                src: "/images/explore-nuestra-bodega-desk-x2.jpg",
                srcSet: "/images/explore-nuestra-bodega-mobile-x2.jpg",
                label: "Explore nuestra bodega",
                href: "/tienda"
            },
            {
                src: "/images/disfrute-del-santuario-spa-_-wellness-desk-x2.jpg",
                srcSet: "/images/disfrute-del-santuario-spa-_-wellness-mobile-x2.jpg",
                label: "Disfrute del Santuario SPA & Wellness",
                href: "/santuario-spa-valladolid"
            }, 
        ],
        className: className,
        animated: true
    });
};
var RegaleUnaExperiencia = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards, {
        title: "Regale una experiencia",
        className: className,
        cards: [
            {
                src: "/images/aperitivo-campero-desk-381x381.jpg",
                srcSet: "/images/aperitivo-campero-mobile-222x250.jpg",
                label: "Experiencia Aperitivo Campero",
                href: "/tienda/regala-experiencias/aperitivo-campero"
            },
            {
                src: "/images/alojamiento-refectorio-desk-381x381.jpg",
                srcSet: "/images/alojamiento-refectorio-desk-222x250.jpg",
                label: "Experiencia Alojamiento y Refectorio",
                href: "/tienda/regala-experiencias/alojamiento-refectorio"
            },
            {
                src: "/images/alojamiento-bodega-desk-381x381.jpg",
                srcSet: "/images/alojamiento-bodega-desk-222x250.jpg",
                label: "Experiencia Alojamiento y Visita a la Bodega",
                href: "/tienda/regala-experiencias/alojamiento-visita-bodega"
            }, 
        ],
        link: {
            text: "Ver Experiencias",
            href: "/tienda/regala-experiencias"
        },
        linkBefore: true,
        animated: true
    });
};
var ExperienciasUnicas = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards, {
        title: "Experiencias \xfanicas",
        className: className,
        cards: [
            {
                src: "/images/experiencias-de-temporada-desk-381x381.jpg",
                srcSet: "/images/experiencias-de-temporada-mobile-222x250.jpg",
                label: "Experiencias de temporada",
                href: "/experiencias-unicas/temporada"
            },
            {
                src: "/images/experiencias-a-medida-desk-381x381.jpg",
                srcSet: "/images/experiencias-a-medida-mobile-222x250.jpg",
                label: "Experiencias a medida",
                href: "/experiencias-unicas/experiencias-medida-personalizadas"
            },
            {
                src: "/images/regale-una-experiencia-desk-381x381.jpg",
                srcSet: "/images/regale-una-experiencia-mobile-222x250.jpg",
                label: "Regale una experiencia",
                href: "/tienda/regala-experiencias"
            }, 
        ],
        animated: true
    });
};
var DisfruteDelWellness = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards, {
        title: "Disfrute del Wellness en Abad\xeda",
        className: className,
        cards: [
            {
                src: "/images/espacio-unico-desk-381x381.jpg",
                srcSet: "/images/espacio-unico-desk-222x250.jpg",
                label: "Un espacio \xfanico",
                href: "/santuario-spa-valladolid/instalaciones"
            },
            {
                src: "/images/spa-sommelier-desk-381x381.jpg",
                srcSet: "/images/spa-sommelier-desk-222x250.jpg",
                label: "SPA Sommelier",
                href: "/santuario-spa-valladolid/spa-sommelier"
            },
            {
                src: "/images/tratamientos-desk-381x381.jpg",
                srcSet: "/images/tratamientos-desk-222x250.jpg",
                label: "Tratamientos",
                href: "/santuario-spa-valladolid/tratamientos"
            }, 
        ]
    });
};
var UnHotelAMedida = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards, {
        title: "Un hotel a su medida",
        cards: [
            {
                src: "/images/habitaciones-desk-x2.jpg",
                srcSet: "/images/habitaciones-mobile-x2.jpg",
                label: "Habitaciones",
                href: "/hotel-spa-valladolid-ribera-del-duero/habitaciones-hotel-5-estrellas"
            },
            {
                src: "/images/servicios-desk-x2.jpg",
                srcSet: "/images/servicios-mobile-x2.jpg",
                label: "Servicios",
                href: "/hotel-spa-valladolid-ribera-del-duero/servicios-hotel-lujo-piscina"
            },
            {
                src: "/images/escapadas-ledomaine-desk-x2.jpg",
                srcSet: "/images/escapadas-ledomaine-mobile-x2.jpg",
                label: "Escapadas LeDomaine",
                href: "/hotel-spa-valladolid-ribera-del-duero/escapadas-ledomaine-hotel-5-estrellas"
            }, 
        ],
        animated: true,
        className: className
    });
};
var GastronomiaDeAbadia = function(param) {
    var className = param.className, link = param.link, linkBefore = param.linkBefore, refectorio = param.refectorio;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards, {
        title: "La gastronom\xeda de Abad\xeda Retuerta",
        description: true,
        cards: refectorio ? [
            {
                src: "/images/1-home-gastonomia-carrusel-x2-desk-840x840.jpg",
                srcSet: "/images/1-home-gastonomia-carrusel-x2-mobile-444X500.jpg",
                label: "WINEBAR ENTRE VI\xd1EDOS",
                title: "Calicata Terroir Bar",
                href: "/restaurantes-valladolid/calicata-terroir-bar"
            },
            {
                src: "/images/4-home-gastonomia-carrusel-x2-desk-840x840_.jpg",
                srcSet: "/images/4-home-gastonomia-carrusel-x2-mobile-444x500_.jpg",
                label: "Tradici\xf3n y creatividad",
                title: "Vinoteca",
                href: "/restaurantes-valladolid/vinoteca"
            },
            {
                src: "/images/2-home-gastonomia-carrusel-x2-desk-840x840_.jpg",
                srcSet: "/images/2-home-gastonomia-carrusel-x2-mobile-444x500_.jpg",
                label: "Tradici\xf3n y creatividad",
                title: "El Jardin del Claustro",
                href: "/restaurantes-valladolid/terraza-jardin-del-claustro"
            }, 
        ] : [
            {
                src: "/images/3-home-gastonomia-carrusel-x2-desk-840x840_.jpg",
                srcSet: "/images/3-home-gastonomia-carrusel-x2-mobile-444x500_.jpg",
                label: "cocina contempor\xe1nea de corte creativo",
                title: "Refectorio",
                href: "/restaurantes-valladolid/refectorio-estrella-michelin"
            },
            {
                src: "/images/4-home-gastonomia-carrusel-x2-desk-840x840_.jpg",
                srcSet: "/images/4-home-gastonomia-carrusel-x2-mobile-444x500_.jpg",
                label: "Tradici\xf3n y creatividad",
                title: "Vinoteca",
                href: "/restaurantes-valladolid/vinoteca"
            },
            {
                src: "/images/2-home-gastonomia-carrusel-x2-desk-840x840_.jpg",
                srcSet: "/images/2-home-gastonomia-carrusel-x2-mobile-444x500_.jpg",
                label: "Tradici\xf3n y creatividad",
                title: "El Jardin del Claustro",
                href: "/restaurantes-valladolid/terraza-jardin-del-claustro"
            }, 
        ],
        animated: true,
        className: className,
        link: link,
        linkBefore: linkBefore
    });
};
/* harmony default export */ var ab_cards_src = (Cards);



/***/ }),

/***/ 2569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var ab_text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(145);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41257);
/* harmony import */ var _ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ab_paragraph_text_scss__WEBPACK_IMPORTED_MODULE_3__);




var ParagraphText = function(param) {
    var _text = param.text, text = _text === void 0 ? [] : _text, singleColumn = param.singleColumn, className = param.className, content = param.content, noPlus = param.noPlus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), viewMore = ref9[0], setViewMore = ref9[1];
    // console.log("ParagraphText", content, text);
    var parsedHtml = content ? (ref8 = (ref7 = (ref6 = (ref5 = (ref4 = (ref3 = (ref2 = (ref1 = (ref = content === null || content === void 0 ? void 0 : content.replace(/<div>/g, "<p>")) === null || ref === void 0 ? void 0 : ref.replace(/<\/div>/g, "</p>")) === null || ref1 === void 0 ? void 0 : ref1.replace(/<div class/g, "<p class")) === null || ref2 === void 0 ? void 0 : ref2.replace(/<ul>/g, "<p><ul>")) === null || ref3 === void 0 ? void 0 : ref3.replace(/<\/ul>/g, "</ul></p>")) === null || ref4 === void 0 ? void 0 : ref4.replace(/<p>/g, "")) === null || ref5 === void 0 ? void 0 : ref5.replace(/\n/g, "")) === null || ref6 === void 0 ? void 0 : ref6.replace(/\r/g, "")) === null || ref7 === void 0 ? void 0 : ref7.split("</p>")) === null || ref8 === void 0 ? void 0 : ref8.filter(function(e) {
        return e;
    }) : [];
    // console.log("ParagraphText - content", content);
    // console.log("ParagraphText - parsedHtml", parsedHtml);
    // console.log("ParagraphText - text", text);
    if (text.length == 0 && parsedHtml.length == 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "ab-paragraph-text ".concat(className || "", " ").concat(viewMore ? "full" : ""),
        style: {
            // height: maxHeight,
            columnCount: singleColumn ? undefined : 2,
            display: singleColumn ? "flex" : "block",
            columnGap: singleColumn ? undefined : 36,
            columnFill: singleColumn ? undefined : "balance"
        },
        children: [
            parsedHtml === null || parsedHtml === void 0 ? void 0 : parsedHtml.map(function(itm, index) {
                if (!itm) {
                    return null;
                }
                if (noPlus) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        className: "no-plus show",
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (index == 0 || parsedHtml.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? parsedHtml.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || parsedHtml.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (parsedHtml.length > 1 && index == parsedHtml.length - 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? function() {
                            return setViewMore(!viewMore);
                        } : null,
                        id: viewMore ? "less" : undefined,
                        className: viewMore && (itm === null || itm === void 0 ? void 0 : itm.includes("<ul>")) ? "less" : "",
                        children: itm
                    }, "paragraph-text-".concat(index));
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            }),
            text === null || text === void 0 ? void 0 : text.filter(function(e) {
                return e;
            }).map(function(itm, index) {
                if (index == 0 || text.length == 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? text.length == 1 ? function() {
                            return setViewMore(!viewMore);
                        } : null : function() {
                            return setViewMore(!viewMore);
                        },
                        className: viewMore || text.length == 1 ? "no-plus" : index == 0 ? "plus" : undefined,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                } else if (text.length > 1 && index == text.length - 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        onClick: viewMore ? function() {
                            return setViewMore(!viewMore);
                        } : null,
                        id: viewMore ? "less" : undefined,
                        children: itm
                    }, "paragraph-text-".concat(index));
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ab_text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    children: itm
                }, "paragraph-text-".concat(index));
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParagraphText);


/***/ }),

/***/ 88389:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 55723:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 34331:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 41257:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);